import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Notification } from "../../generated/graphql";
import { addTime } from "../../utils/formatDate";
import { setRateNotifier } from "../../features/utils.features";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

interface props {
  isOpen: boolean;
  setIsOpen: () => void;
  data: Omit<Notification, "from" | "to">;
}

// export default function RewardPrompt({ isOpen, onClose, data }: props) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   function setReminder() {
//     dispatch(setRateNotifier(JSON.stringify(addTime(60).added)));
//     onClose();
//   }

//   return (
//     <div style={{ fontFamily: "Airbnb Cereal App" }}>
//       <Modal
//         closeOnOverlayClick={false}
//         isOpen={isOpen}
//         onClose={onClose}
//         isCentered
//         size="xs"
//       >
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader className="text-[#1A222F] font-bold dark:text-black">
//             "You have Earned 25 AFYA"
//           </ModalHeader>

//           <ModalBody>
//             <p className="dark:text-black">
//               To receive it, please proceed to rate your experience at the
//               clinic.
//             </p>
//           </ModalBody>

//           <ModalFooter className="flex w-full gap-3 justify-center">
//             <button
//               className="bg-blue-500 px-6 py-2.5 rounded-full text-white font-bold"
//               onClick={setReminder}
//             >
//               Rate Later
//             </button>

//             <button
//               className="bg-blue-500 px-6 py-2.5 rounded-full text-white font-bold"
//               onClick={() => {
//                 navigate("/app/account/ratings", {
//                   state: {
//                     id: data.dataId,
//                   },
//                 });
//                 onClose();
//               }}
//             >
//               Rate Now
//             </button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </div>
//   );
// }

function SessionModal({ isOpen, setIsOpen, data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function setReminder() {
    dispatch(setRateNotifier(JSON.stringify(addTime(60).added)));
    setIsOpen(false);
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-100"
        onClose={() => {
          setIsOpen(false);
        }}
        style = {{zIndex: '100000000000000000000000000000000000000000000000'}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="w-full max-w-md transform overflow-hidden rounded-2xl dark:text-white bg-white dark:bg-[#343B46] p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title className="text-lg font-bold mb-6">
                  "You have Earned 25 AFYA"
                </Dialog.Title>

                <p>
                  To receive it, please proceed to rate your experience at the
                  clinic.
                </p>

                <div className="flex w-full gap-3 justify-center mt-6">
                  <button
                    className="bg-blue-500 px-6 py-2.5 rounded-full text-white font-bold"
                    onClick={setReminder}
                  >
                    Rate Later
                  </button>

                  <button
                    className="bg-blue-500 px-6 py-2.5 rounded-full text-white font-bold"
                    onClick={() => {
                      navigate("/app/account/ratings", {
                        state: {
                          id: data.dataId,
                        },
                      });
                      setIsOpen(false);
                    }}
                  >
                    Rate Now
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default SessionModal;
